import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../api";

let _menuP = null;
const getMenu = () => (_menuP = _menuP || api.get("/table-menu").then((r) => r.data).catch(() => { _menuP = null; return null; }));

export const EndDishOffer = ({ prefer = "butter chicken" }) => {
  const navigate = useNavigate();
  const [dish, setDish] = useState(null);
  useEffect(() => {
    getMenu().then((m) => {
      const ds = (m && m.dishes) || [];
      setDish(ds.find((d) => d.name.trim().toLowerCase() === prefer) || ds.find((d) => d.name.toLowerCase().includes(prefer)) || ds[0] || null);
    });
  }, [prefer]);
  if (!dish) return null;
  const add = () => {
    let cart = {};
    try { cart = JSON.parse(localStorage.getItem("up_cart") || "{}"); } catch { cart = {}; }
    cart[dish.slug] = { slug: dish.slug, name: dish.name, price: dish.price, image: dish.image || null, qty: (cart[dish.slug]?.qty || 0) + 1 };
    localStorage.setItem("up_cart", JSON.stringify(cart));
    toast.success(`${dish.name} added`);
    navigate("/go/cart");
  };
  return (
    <div data-testid="end-dish-offer" className="mt-3 rounded-xl border border-[#D4AF37]/40 bg-[#14100A] p-3 flex items-center gap-3 text-left">
      {dish.image && (
        <img src={dish.image} alt="" className="w-12 h-12 rounded-full object-cover flex-none"
          style={{ boxShadow: "0 0 12px rgba(244,163,0,0.4), inset 0 0 10px rgba(0,0,0,0.6)" }} />
      )}
      <p className="flex-1 text-xs text-white/70 m-0">Hungry? <b className="text-[#F0C742]">{dish.name}</b> is 2 taps away</p>
      <button data-testid="end-dish-add" onClick={add}
        className="flex-none bg-[#D4AF37] text-black font-black text-xs tracking-wide rounded-full px-4 py-2 hover:bg-[#F0C742]">
        + Add · ${Number(dish.price).toFixed(2)}
      </button>
    </div>
  );
};
